// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + ({"1721":"SingleEvent","1789":"Calendar","1801":"EmptyState","5242":"CardsMobile","5528":"CompactMobile","6932":"SideBySide","7468":"Cards","8545":"ListLayout"}[chunkId] || chunkId) + ".chunk.min.js";
};